import InstrumentTile from './InstrumentTile';

// eslint-disable-next-line import/prefer-default-export
export { InstrumentTile };
